export const isMobile = (mobile: string) => {
  if (!/^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(mobile)) {
    return false;
  }

  return true;
};

export const isPassword = (password: string) => {
  return /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))^.{8,16}$/.test(password);
};

export const isHyperlink = (url: string) => {
  if (/^http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?$/.test(url)) {
    return true;
  }

  return false;
};

export const isAccount = (account: string) => {
  return /^(?!.*[_@.]{2})[a-zA-Z0-9_@.]{1,64}$/.test(account);
};
